const redirectToLogin = ()=>{
    window.location.href= "http://www.baidu.com"
}

const baseURL = 'https://service-l5srq9hk-1317980866.gz.apigw.tencentcs.com/release/'

export {
    redirectToLogin,
    baseURL
}